










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Models
import {
  BudgetPaymentMethod,
  BudgetPaymentMethodLiteral,
} from '@/manager/budget/models/budget.model.ts';

// Components
import ItemThumb, {
  ItemThumbPrefeginedStyle,
  TittleFontFamily,
  SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';
import GroupButton, {
  GroupButtonPredefinedStyle,
} from '@/shared/components/group-button.component.vue';

// Views
import PaymentMethodCard from '@/client/budget/views/acceptance/choose-payment-method/payment-method-card/index.vue';
import PaymentMethodDirectDebit from '@/client/budget/views/acceptance/choose-payment-method/payment-method-direct-debit/index.vue';
import PaymentMethodWireTransfer from '@/client/budget/views/acceptance/choose-payment-method/payment-method-wire-transfer/index.vue';
import BillingData from '@/client/budget/views/acceptance/choose-payment-method/billing-data/index.vue';

@Component({
  components: {
    BillingData,
    ItemThumb,
    GroupButton,
    PaymentMethodCard,
    PaymentMethodDirectDebit,
    PaymentMethodWireTransfer,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      showCardMethodPartial: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      showDirectDebitMethodPartial:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
      showSendWireTransferMethodPartial:
        'isWireTransferMethodSelectedInCurrentBudgetAcceptance',
    }),
  },
})
export default class ChoosePaymentMethod extends Vue {
  @Prop({default: false}) textStyle?:any
  @Prop() prop?:any
  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private tittleFontFamily = TittleFontFamily;
  private subtitleFontFamily = SubtitleFontFamily;
  private currentBudget!: any;
  private showCardMethodPartial!: any;
  private showDirectDebitMethodPartial!: any;
  private showSendWireTransferMethodPartial!: any;
  private setCurrentBudgetAcceptance!: any;
  private literals = {
    title: 'Forma de Pago Aplazado',
    subtitle: 'Selecciona la forma de pago aplazado',
  };

  get paymentOptions() {
    return [
      {
        id: BudgetPaymentMethod.DirectDebit.toString(),
        text: BudgetPaymentMethodLiteral[BudgetPaymentMethod.DirectDebit],
      },
      {
        id: BudgetPaymentMethod.Card.toString(),
        text: BudgetPaymentMethodLiteral[BudgetPaymentMethod.Card],
      },
    ];
  }

  get currentBudgetPaymentMethod() {
    let method = '';
    if (this.currentBudget.paymentMethod) {
      method = this.currentBudget.paymentMethod.toString();
    }
    return method;
  }
}
